// create component ResetPasswordPage to reset password and use same layout in ForgetPasswordPage
import { use, useActionState, useEffect } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Label from "../../components/label";
import Input from "../../components/input";
import { Button } from "../../components/button";
import {
  AtSymbolIcon,
  ExclamationCircleIcon,
  ArrowRightIcon,
  KeyIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import FormError from "../../components/form-error";
import Fonts from "../../core/fonts";
import { resetPassword, State } from "./actions/resetPassword";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") || "/";
  const email = searchParams.get("email") || "";

  const initialState: State = {
    errors: {},
    error: {
      message: "",
      code: "",
    },
    success: false,
    defaultValues: {
      email: email,
      password: "",
      confirmPassword: "",
      code: "",
    },
  };
  const [state, formAction, isPending] = useActionState(
    resetPassword,
    initialState
  );

  useEffect(() => {
    if (state?.success) {
      navigate("/auth/login");
    }
  }, [state, callbackUrl]);

  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    auth.loaded(false);
  };

  return (
    <div className="flex items-center justify-center flex-1">
      <form
        className="space-y-3 w-full max-w-md"
        action={formAction}
        onSubmit={handleOnSubmit}
      >
        <div className="flex-1 rounded-lg bg-gray-50 px-6 pb-4 pt-8">
          <h1 className={`${Fonts.lusitanaRegular} mb-3 text-2xl`}>
            Reset your password?
          </h1>
          <p>Enter your new password below.</p>
          <div className="w-full text-left">
            <input
              name="email"
              type="hidden"
              value={state && state.defaultValues?.email}
            />
            <div className="mt-4">
              <Label className="text-xs mb-3 text-gray-900" htmlFor="code">
                Code
              </Label>
              <Input
                id="code"
                type="text"
                name="code"
                placeholder="Enter the reset code"
                required
                Icon={AtSymbolIcon}
                aria-describedby="code-error"
                defaultValue={state && state.defaultValues?.code}
              />
              <FormError
                id="code-error"
                message={state && state.errors?.code}
              ></FormError>
            </div>
            <div className="mt-4">
              <Label className="text-xs mb-3 text-gray-900" htmlFor="password">
                New Password
              </Label>
              <Input
                id="password"
                type="password"
                name="password"
                placeholder="Enter new password"
                required
                Icon={KeyIcon}
                aria-describedby="password-error"
              />
              <FormError
                id="password-error"
                message={state && state.errors?.password}
              ></FormError>
            </div>
            <div className="mt-4">
              <Label
                className="text-xs mb-3 text-gray-900"
                htmlFor="confirmPassword"
              >
                Confirm New Password
              </Label>
              <Input
                id="confirmPassword"
                type="password"
                name="confirmPassword"
                placeholder="Confirm new password"
                required
                Icon={KeyIcon}
                aria-describedby="confirmPassword-error"
              />
              <FormError
                id="confirmPassword-error"
                message={state && state.errors?.confirmPassword}
              ></FormError>
            </div>
          </div>
          <div className="flex flex-col  items-end space-x-1">
            {state && !state.success && state.error && state.error.message && (
              <>
                <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
                <p className="text-sm text-red-500">{state.error.message}</p>
              </>
            )}

            <Button className="mt-4 w-full" aria-disabled={isPending}>
              Reset Password
              <ArrowRightIcon className="ml-auto h-5 w-5 text-gray-50" />
            </Button>

            <div className="mt-1 flex w-full items-center justify-around text-purple-500">
              <Link to={"/auth/login"}>
                <span>Back to Login</span>
              </Link>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
